export enum PRICE_SOURCES {
  HEDGE = 'HEDGE',
  MARKET = 'MARKET',
}

export type PriceSources = 'HEDGE' | 'MARKET';
